import styled from "styled-components";
import {
  secondaryColor,
  primary,
  accentGrey,
  lightInactive,
  greyDark,
  grey,
  primayColor,
  blackAlpha,
  onHoverDropShadow,
} from "../variable";
import { Field } from "formik";
// import { StyledTextEditorActionButton } from "../details/stylesDetails";

export const StyledTextEditorActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  color: ${lightInactive};
  font-size: 1.125rem;
  line-height: 1.375rem;
  font-family: "Rubik" !important;
  width: auto !important;

  :hover:not([disabled]) {
    color: ${primary} !important;
    outline: none !important;
  }

  :focus {
    outline: none !important;
  }

  :disabled {
    color: ${accentGrey};
    cursor: not-allowed;
  }

  &.active {
    color: ${primary};
  }
`;

export const StyledSettingsBaseDiv = styled.div`
  ${"" /* margin-top: 100px; */}
  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

export const StyledSettingsContainer = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
  }

  .mob {
    @media (max-width: 768px) {
      overflow: auto;
    }
  }
`;

// For 'FIRST NAME' , 'LAST NAME' , 'EMAIL ADDRESS', 'USERNAME', etc on the right side sections
export const StyledBasicsSectionLabels = styled.label`
  height: 17px;
  width: 150px;
  color: #9ea0a5;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
`;

export const StyledFormField = styled(Field)`
  background-color: ${primayColor};
  border: 0px;
  color: ${grey};
  height: 38px;
  border-radius: 8px;
  padding-left: 1rem;
  font-size: 1rem;
  letter-spacing: 0.08px;
  line-height: 28px;

  &::placeholder {
    font-size: 1rem;
    letter-spacing: 0.08px;
    line-height: 28px;
  }

  &:-ms-input-placeholder {
    background-color: ${primayColor} !important;
    color: ${grey};
    font-size: 1rem;
    letter-spacing: 0.08px;
    line-height: 28px;
  }

  &::-ms-input-placeholder {
    background-color: ${primayColor} !important;
    color: ${grey};
    font-size: 1rem;
    letter-spacing: 0.08px;
    line-height: 28px;
  }

  .input {
    background-color: ${primayColor} !important;
    color: ${grey} !important;
    outline: none;
  }

  :focus {
    color: ${grey};
    background-color: ${primayColor} !important;
  }
  :hover {
    border: 1px ${primary} solid !important;
  }
`;

export const StyledFormRows = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledBrandKitContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledBrandKitColumn = styled.div`
  float: left;
  width: 100%;
`;

export const StyledBrandKitPaletteContainer = styled.div`
  background-color: ${secondaryColor};
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 60px));
  grid-gap: 0.75rem;
  margin: 0rem 0rem 0.25rem 0rem;
  border-radius: 8px;
  padding: 0.75rem;
  width: 100%;
  justify-content: space-evenly;
`;

export const StyledBrandKitLogosGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(150px, auto);
  grid-gap: 1em;
  margin-bottom: 2rem;

  .add-logos-container {
    height: 100%;
    width: 100%;
    border-radius: 8px;
    border: 2px dotted ${grey};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .thumbnail {
    height: 100%;
    width: 100%;
    border: 3px transparent solid;
    position: relative;

    .placeholder {
      height: 100%;
      width: 100%;

      img {
        object-fit: scale-down;
        height: 100%;
        width: 100%;
      }
    }

    :hover {
      border-radius: 8px;

      box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};

      img {
        opacity: 0.4;
      }
    }

    .actions {
      width: min-content;
      position: absolute;
      top: 5px;
      right: 8px;

      svg {
        cursor: pointer;
        color: ${primary};
      }
    }
  }
`;

export const StyledColorPickerButtonSettings = styled(
  StyledTextEditorActionButton
)`
  width: ${(props) =>
    props.showColorCode
      ? "auto"
      : props.showValue
      ? "68px"
      : props.onlyInput
      ? "135px"
      : "32px"} !important;
  height: 32px !important;
  border: 1px solid ${accentGrey} !important;
  border-radius: 0px 4px 4px 0px;
`;

export const StyledColorPickerIconButtonSettings = styled(
  StyledTextEditorActionButton
)`
  width: ${(props) =>
    props.showColorCode
      ? "auto"
      : props.showValue
      ? "68px"
      : props.onlyInput
      ? "135px"
      : "32px"} !important;
  height: 32px !important;
  border: 1px solid ${accentGrey} !important;
  border-radius: ${(props) =>
    props.divType === "input" ? "0px" : "4px 0px 0px 4px"};
`;

export const StyledBrandkitSectionLabels = styled.div`
  border-bottom: 1px solid ${blackAlpha};
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  label {
    height: 17px;
    width: 150px;
    color: ${lightInactive};
    font-family: Rubik;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
    text-transform: capitalize;
  }
`;
